import { Switch } from "@headlessui/react";
import { ThemeContext } from "../contexts/ThemeContext";

import React, { useContext, useState } from "react";
import { portfolioConfig } from "../config/portfolio.config";

const Settings = () => {
  const { darkMode, toggleDarkMode } = useContext(ThemeContext);
  const [privateAccount, setPrivateAccount] = useState(false);
  const [emailNotifications, setEmailNotifications] = useState(true);

  const handleLogout = () => {
    // Implement logout functionality
    console.log("User logged out");
  };

  return (
    <div
      className={`max-w-2xl mx-auto px-4 py-8 ${
        darkMode ? "text-white" : "text-black"
      }`}
    >
      <h1 className="mb-6 text-2xl font-bold">Settings</h1>

      <div
        className={`${
          darkMode ? "bg-gray-900" : "bg-white"
        } shadow rounded-lg divide-y`}
      >
        <div className="p-6">
          <h2 className="mb-4 text-xl font-semibold">Account</h2>
          <div className="flex items-center justify-between mb-4">
            <span>Username</span>
            <span className="text-gray-600">{portfolioConfig.username}</span>
          </div>
          <div className="flex items-center justify-between mb-4">
            <span>Email</span>
            <span className="text-gray-600">{portfolioConfig.email}</span>
          </div>
          <button
            className="px-4 py-2 mt-4 text-white transition-colors bg-blue-500 rounded hover:bg-blue-600"
            onClick={() => console.log("Change password")}
          >
            Change Password
          </button>
        </div>

        <div className="p-6">
          <h2 className="mb-4 text-xl font-semibold">Preferences</h2>
          <div className="flex items-center justify-between mb-4">
            <span>Dark Mode</span>
            <Switch
              checked={darkMode}
              onChange={toggleDarkMode}
              className={`${
                darkMode ? "bg-blue-600" : "bg-gray-200"
              } relative inline-flex items-center h-6 rounded-full w-11`}
            >
              <span className="sr-only">Enable Dark Mode</span>
              <span
                className={`${
                  darkMode ? "translate-x-6" : "translate-x-1"
                } inline-block w-4 h-4 transform bg-white rounded-full`}
              />
            </Switch>
          </div>
          <div className="flex items-center justify-between mb-4">
            <span>Private Account</span>
            <Switch
              checked={privateAccount}
              onChange={setPrivateAccount}
              className={`${
                privateAccount ? "bg-blue-600" : "bg-gray-200"
              } relative inline-flex items-center h-6 rounded-full w-11`}
            >
              <span className="sr-only">Enable Private Account</span>
              <span
                className={`${
                  privateAccount ? "translate-x-6" : "translate-x-1"
                } inline-block w-4 h-4 transform bg-white rounded-full`}
              />
            </Switch>
          </div>
          <div className="flex items-center justify-between">
            <span>Email Notifications</span>
            <Switch
              checked={emailNotifications}
              onChange={setEmailNotifications}
              className={`${
                emailNotifications ? "bg-blue-600" : "bg-gray-200"
              } relative inline-flex items-center h-6 rounded-full w-11`}
            >
              <span className="sr-only">Enable Email Notifications</span>
              <span
                className={`${
                  emailNotifications ? "translate-x-6" : "translate-x-1"
                } inline-block w-4 h-4 transform bg-white rounded-full`}
              />
            </Switch>
          </div>
        </div>

        <div className="p-6">
          <h2 className="mb-4 text-xl font-semibold">Actions</h2>
          <button
            className="w-full px-4 py-2 text-white transition-colors bg-red-500 rounded hover:bg-red-600"
            onClick={handleLogout}
          >
            Log Out
          </button>
        </div>
      </div>
    </div>
  );
};

export default Settings;
